export default {
  BFS: [
    "Alicante",
    "Almeria",
    "Alpes–Isère Airport",
    "Amsterdam",
    "Amsterdam Intl",
    "Antalya",
    "Arrecife",
    "Athens",
    "Barcelona",
    "Barra",
    "Basel",
    "Belfast City",
    "Belfast Intl",
    "Belgrade",
    "Benbecula",
    "Bergen",
    "Berlin",
    "Bilbao",
    "Billund",
    "Birmingham",
    "Bodrum",
    "Bologna",
    "Bordeaux",
    "Bordeaux–Merignac",
    "Bourgas",
    "Bristol",
    "Brussels",
    "Bucharest",
    "Budapest",
    "Bydgoszcz Ignacy Jan Paderewski Airport",
    "Campbeltown",
    "Cancun",
    "Cape Verde",
    "Carcassonne",
    "Cardiff",
    "Cayo Coco",
    "Chambery",
    "Chania",
    "Charleroi",
    "City of Derry",
    "Copenhagen",
    "Corfu",
    "Cork",
    "Dalaman",
    "Donegal",
    "Dubai",
    "Dublin",
    "Dubrovnik",
    "Duesseldorf",
    "Dusseldorf",
    "East Midlands Airport",
    "Edinburgh",
    "Enfidha",
    "Exeter",
    "Faro",
    "Frankfurt",
    "Fuerteventura",
    "Funchal",
    "Gdansk",
    "Geneva",
    "Girona Airport",
    "Glasgow Airport",
    "Goteborg",
    "Gran Canaria",
    "Grantley Adams International Airport",
    "Guernsey Airport",
    "Halifax",
    "Halkidiki",
    "Hamburg",
    "Hannover",
    "Helsinki",
    "Henri Coandă International Airport",
    "Heraklion",
    "Hurghada",
    "Ibiza",
    "Islay",
    "Isle Of Man",
    "Izmir Adnan Menderes Airport",
    "Jardines del Rey Airport",
    "Jersey",
    "Katowice",
    "Kefalonia",
    "Kiev",
    "Kirkwall",
    "Kittila",
    "Kos",
    "Krakow",
    "Kraków",
    "Larnaca",
    "Las Vegas",
    "Lisbon",
    "London City",
    "London Gatwick",
    "London Heathrow",
    "London Luton",
    "London Southend",
    "London Stansted",
    "Luxembourg",
    "Lyon",
    "Madrid",
    "Malaga",
    "Malta Airport",
    "Manchester",
    "Marrakesh",
    "Marseille",
    "Menorca",
    "Milan",
    "Montego Bay",
    "Moscow",
    "Munich",
    "Naples",
    "New York - JFK",
    "New York - Newark",
    "Newquay",
    "Nice",
    "Norwich",
    "Nuremberg",
    "Orlando",
    "Oslo",
    "Palanga",
    "Palma",
    "Palma de Mallorca",
    "Paphos",
    "Paris",
    "Paris CDG",
    "Porto",
    "Prague",
    "Reus Airport",
    "Reykjavik",
    "Rhodes",
    "Riga",
    "Rome",
    "Rovaniemi",
    "Salzburg",
    "Sharm El Sheikh",
    "Sofia",
    "Southampton",
    "Split",
    "Stockholm",
    "Stornoway",
    "Stuttgart",
    "Sumburgh",
    "Tenerife South",
    "Tiree",
    "Toronto",
    "Toulouse",
    "Turin",
    "Valencia",
    "Vancouver",
    "Venice",
    "Verona",
    "Vienna",
    "Warsaw",
    "Wroclaw",
    "Zagreb",
    "Zante",
    "Zurich",
    "Other",
  ],
  //--------------------------------------------------------------------//
  BHX: [
    "Alicante",
    "Almeria",
    "Amsterdam",
    "Antalya",
    "Arrecife (Lanzarote)",
    "Barcelona",
    "Berlin",
    "Birmingham",
    "Bordeaux",
    "Bourgas",
    "Bristol",
    "Cancun",
    "Crete",
    "Dubrovnik",
    "Edinburgh",
    "Faro",
    "Fuerteventura",
    "Gdansk",
    "Geneva",
    "Gerona",
    "Glasgow",
    "Ibiza",
    "Isle of Man",
    "Jersey",
    "Katowice",
    "Krakow",
    "Las Palmas",
    "Las Vegas",
    "Liverpool",
    "London Gatwick",
    "London Luton",
    "London Stansted",
    "Lyon",
    "Madeira",
    "Mahon (Majorca)",
    "Malaga",
    "Malta",
    "Manchester",
    "Milan",
    "Naples",
    "Newcastle",
    "Nice",
    "Orlando",
    "Palma Majorca",
    "Paphos",
    "Paris Charles de Gaulle",
    "Plovdiv",
    "Prague",
    "Reus",
    "Reykjavik",
    "Salzburg",
    "Split",
    "Tenerife",
    "Valenica",
    "Varadero",
    "Venice",
    "Verona",
    "Vilnius",
    "Warsaw",
    "Wroclaw",
    "Zante",
    "Other",
  ],
  //--------------------------------------------------------------------//
  BH2: [
    "Alicante",
    "Almeria",
    "Amsterdam",
    "Antalya",
    "Arrecife (Lanzarote)",
    "Barcelona",
    "Berlin",
    "Birmingham",
    "Bordeaux",
    "Bourgas",
    "Bristol",
    "Cancun",
    "Crete",
    "Dubrovnik",
    "Edinburgh",
    "Faro",
    "Fuerteventura",
    "Gdansk",
    "Geneva",
    "Gerona",
    "Glasgow",
    "Ibiza",
    "Isle of Man",
    "Jersey",
    "Katowice",
    "Krakow",
    "Las Palmas",
    "Las Vegas",
    "Liverpool",
    "London Gatwick",
    "London Luton",
    "London Stansted",
    "Lyon",
    "Madeira",
    "Mahon (Majorca)",
    "Malaga",
    "Malta",
    "Manchester",
    "Milan",
    "Naples",
    "Newcastle",
    "Nice",
    "Orlando",
    "Palma Majorca",
    "Paphos",
    "Paris Charles de Gaulle",
    "Plovdiv",
    "Prague",
    "Reus",
    "Reykjavik",
    "Salzburg",
    "Split",
    "Tenerife",
    "Valenica",
    "Varadero",
    "Venice",
    "Verona",
    "Vilnius",
    "Warsaw",
    "Wroclaw",
    "Zante",
    "Other",
  ],
  //--------------------------------------------------------------------//
  DRW: [],
  //--------------------------------------------------------------------//
  FM1: [],
  //--------------------------------------------------------------------//
  FMM: [
    "Alicante",
    "Almeria",
    "Amsterdam",
    "Antalya",
    "Arrecife (Lanzarote)",
    "Barcelona",
    "Berlin",
    "Birmingham",
    "Bordeaux",
    "Bourgas",
    "Bristol",
    "Cancun",
    "Crete",
    "Dubrovnik",
    "Edinburgh",
    "Faro",
    "Fuerteventura",
    "Gdansk",
    "Geneva",
    "Gerona",
    "Glasgow",
    "Ibiza",
    "Isle of Man",
    "Jersey",
    "Katowice",
    "Krakow",
    "Las Palmas",
    "Las Vegas",
    "Liverpool",
    "London Gatwick",
    "London Luton",
    "London Stansted",
    "Lyon",
    "Madeira",
    "Mahon (Majorca)",
    "Malaga",
    "Malta",
    "Manchester",
    "Milan",
    "Naples",
    "Newcastle",
    "Nice",
    "Orlando",
    "Palma Majorca",
    "Paphos",
    "Paris Charles de Gaulle",
    "Plovdiv",
    "Prague",
    "Reus",
    "Reykjavik",
    "Salzburg",
    "Split",
    "Tenerife",
    "Valenica",
    "Varadero",
    "Venice",
    "Verona",
    "Vilnius",
    "Warsaw",
    "Wroclaw",
    "Zante",
    "Other",
  ],
  //--------------------------------------------------------------------//
  HER: [],
  //--------------------------------------------------------------------//
  HVN: [],
  //--------------------------------------------------------------------//
  INV: [],
  //--------------------------------------------------------------------//
  IP1: [
    "Alicante",
    "Almeria",
    "Alpes–Isère Airport",
    "Amsterdam",
    "Amsterdam Intl",
    "Antalya",
    "Arrecife",
    "Athens",
    "Barcelona",
    "Barra",
    "Basel",
    "Belfast City",
    "Belfast Intl",
    "Belgrade",
    "Benbecula",
    "Bergen",
    "Berlin",
    "Bilbao",
    "Billund",
    "Birmingham",
    "Bodrum",
    "Bologna",
    "Bordeaux",
    "Bordeaux–Merignac",
    "Bourgas",
    "Bristol",
    "Brussels",
    "Bucharest",
    "Budapest",
    "Bydgoszcz Ignacy Jan Paderewski Airport",
    "Campbeltown",
    "Cancun",
    "Cape Verde",
    "Carcassonne",
    "Cardiff",
    "Cayo Coco",
    "Chambery",
    "Chania",
    "Charleroi",
    "City of Derry",
    "Copenhagen",
    "Corfu",
    "Cork",
    "Dalaman",
    "Donegal",
    "Dubai",
    "Dublin",
    "Dubrovnik",
    "Duesseldorf",
    "Dusseldorf",
    "East Midlands Airport",
    "Edinburgh",
    "Enfidha",
    "Exeter",
    "Faro",
    "Frankfurt",
    "Fuerteventura",
    "Funchal",
    "Gdansk",
    "Geneva",
    "Girona Airport",
    "Glasgow Airport",
    "Goteborg",
    "Gran Canaria",
    "Grantley Adams International Airport",
    "Guernsey Airport",
    "Halifax",
    "Halkidiki",
    "Hamburg",
    "Hannover",
    "Helsinki",
    "Henri Coandă International Airport",
    "Heraklion",
    "Hurghada",
    "Ibiza",
    "Islay",
    "Isle Of Man",
    "Izmir Adnan Menderes Airport",
    "Jardines del Rey Airport",
    "Jersey",
    "Katowice",
    "Kefalonia",
    "Kiev",
    "Kirkwall",
    "Kittila",
    "Kos",
    "Krakow",
    "Kraków",
    "Larnaca",
    "Las Vegas",
    "Lisbon",
    "London City",
    "London Gatwick",
    "London Heathrow",
    "London Luton",
    "London Southend",
    "London Stansted",
    "Luxembourg",
    "Lyon",
    "Madrid",
    "Malaga",
    "Malta Airport",
    "Manchester",
    "Marrakesh",
    "Marseille",
    "Menorca",
    "Milan",
    "Montego Bay",
    "Moscow",
    "Munich",
    "Naples",
    "New York - JFK",
    "New York - Newark",
    "Newquay",
    "Nice",
    "Norwich",
    "Nuremberg",
    "Orlando",
    "Oslo",
    "Palanga",
    "Palma",
    "Palma de Mallorca",
    "Paphos",
    "Paris",
    "Paris CDG",
    "Porto",
    "Prague",
    "Reus Airport",
    "Reykjavik",
    "Rhodes",
    "Riga",
    "Rome",
    "Rovaniemi",
    "Salzburg",
    "Sharm El Sheikh",
    "Sofia",
    "Southampton",
    "Split",
    "Stockholm",
    "Stornoway",
    "Stuttgart",
    "Sumburgh",
    "Tenerife South",
    "Tiree",
    "Toronto",
    "Toulouse",
    "Turin",
    "Valencia",
    "Vancouver",
    "Venice",
    "Verona",
    "Vienna",
    "Warsaw",
    "Wroclaw",
    "Zagreb",
    "Zante",
    "Zurich",
    "Other",
  ],
  //--------------------------------------------------------------------//
  JER: [],
  //--------------------------------------------------------------------//
  LAX: [],
  //--------------------------------------------------------------------//
  LDY: [
    "Algarve",
    "Birmingham",
    "Faro",
    "Glasgow",
    "London Heathrow",
    "Lourdes",
    "Manchester",
    "Verona",
    "Other",
  ],
  //--------------------------------------------------------------------//
  ML1: [],
  //--------------------------------------------------------------------//
  NOC: [],
  //--------------------------------------------------------------------//
  NQY: [],
  //--------------------------------------------------------------------//
  NWI: [],
  //--------------------------------------------------------------------//
  NUE: [
    "Alicante",
    "Almeria",
    "Amsterdam",
    "Antalya",
    "Arrecife (Lanzarote)",
    "Barcelona",
    "Berlin",
    "Birmingham",
    "Bordeaux",
    "Bourgas",
    "Bristol",
    "Cancun",
    "Crete",
    "Dubrovnik",
    "Edinburgh",
    "Faro",
    "Fuerteventura",
    "Gdansk",
    "Geneva",
    "Gerona",
    "Glasgow",
    "Ibiza",
    "Isle of Man",
    "Jersey",
    "Katowice",
    "Krakow",
    "Las Palmas",
    "Las Vegas",
    "Liverpool",
    "London Gatwick",
    "London Luton",
    "London Stansted",
    "Lyon",
    "Madeira",
    "Mahon (Majorca)",
    "Malaga",
    "Malta",
    "Manchester",
    "Milan",
    "Naples",
    "Newcastle",
    "Nice",
    "Orlando",
    "Palma Majorca",
    "Paphos",
    "Paris Charles de Gaulle",
    "Plovdiv",
    "Prague",
    "Reus",
    "Reykjavik",
    "Salzburg",
    "Split",
    "Tenerife",
    "Valenica",
    "Varadero",
    "Venice",
    "Verona",
    "Vilnius",
    "Warsaw",
    "Wroclaw",
    "Zante",
    "Other",
  ],
  //--------------------------------------------------------------------//
  PB1: [],
  //--------------------------------------------------------------------//
  PIT: [],
  //--------------------------------------------------------------------//
  PV1: [],
  //--------------------------------------------------------------------//
  RDU: [],
  //--------------------------------------------------------------------//
  RSW: [],
  //--------------------------------------------------------------------//
  SV1: [],
  //--------------------------------------------------------------------//
  SZG: [],
  //--------------------------------------------------------------------//
  YHM: [],
  //--------------------------------------------------------------------//
};